import React, { useEffect, useState,useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import { Filter } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import SiteStageCard from 'components/sales/cardSection/siteStageCard/siteStageCard';
import { Link, NavLink } from 'react-router-dom';
import "./siteStage.css";
// import "./siteStage.css";
import { Button } from "react-bootstrap";
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from "../../../components/sales/Input/dropDownInput/dropDownInput";
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import TableSection from "../../../components/sales/tableSection/tableSection";
import { toast } from 'react-toastify';
import useLatLng from 'hooks/uselatlng/uselatlng';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import {getIssuesList, saveSiteIssues} from "../../../services/redux/installation/siteStages/action";
import CardSection from "components/sales/cardSection/cardSection";
import { ISSUE_DEPARTMENTS, getIssueSubcategories } from "./issueCategoryOptions";
import { calcCrow } from 'services/utils/helpers/customHelper';
import {shouldShowSiteCheckinModal, isActiveDistanceCheckin} from 'services/attendance/isActiveDistanceCheckin';
import {
  checkoutErrorMessage,
  getSiteLatLng,
  isCheckoutApiSuccess,
  resolveDistanceRowId,
} from 'services/attendance/siteCheckout';

const SiteListing = ({
  getSiteStage,
  siteStageData,
  siteDetails,
  history,
  latitude,
  longitude,
  match,
  isVendorAllocated,
  siteStageStatus,
  siteDismantle,
  siteUnhold,
  userProfile,
  getCheckLocation,locationCheck,
  getSiteData,
  calculateDistance,
  siteData,
  getDistanceDataDailyTaskAtt,
  dailyDistance,
  getDistanceData,
  refreshAfterSiteCheckout,
  distanceDetails,
  engDistanceData,
  saveSiteIssues,
  issuesList,
  getIssuesList,
  getProfile,
  is_asset_mapping,
  infraProjectId,
  isCarnivalScheduled,
  receivedAmount,
  siteStageDetails=[],
  activeDistanceCheckin,
}) => {

  /** Key absent → false. Key present + array with length 0 → true; otherwise false (card shows training warning when false). */
  const resolveIsDashboardTraining = (details) => {
    if (details == null || typeof details !== 'object' || Array.isArray(details)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(details, 'dashboard_training')) {
      return false;
    }
    const v = details.dashboard_training;
    if (Array.isArray(v)) {
      return v.length === 0;
    }
    return false;
  };
  const isDashboardTrainingResolved = resolveIsDashboardTraining(siteStageDetails);

  const inputs = {
    reason :""
  };

  const [siteId, setSiteId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(null);
  const [isResStatusModal, setIsResStatusModal] = useState(true);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [displayButton,setdisplayButton] = useState('none');
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [remarkData, setRemarkData] = useState('');
  const [status, setStatus] = useState('');
  const [responseData, setResponseData] = useState(null);
  const [remarkReasonValue, setRemarkReasonValue] = useState(inputs)
  const [isShowAttPopUp, showAttPopup] = useState(false)
  const [listData, setDailyTaskData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [role, setRole] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [distanceReady, setDistanceReady] = useState(false);
  const islatlng = useLatLng();
  const [showIssuesForm, setShowIssuesForm] = useState(false);
  const [siteStages, setSiteStages] = useState([]);
  const [issueStage, setIssueStage] = useState('');
  const [issueDept, setIssueDept] = useState('');
  const [issueCategory, setIssueCategory] = useState('');
  const [issueRemarks, setIssueRemarks] = useState('');
  const [siteIssuesList, setSiteIssuesList] = useState([]);
  const [issuePageCount, setIssuePageCount] = useState(0);
  const [subcategoryResetKey, setSubcategoryResetKey] = useState(0);
  
  const handleModalHide = () => setIsModal(false);
  const handleModalHide2 = () => {
    setShowIssuesForm(false);
    setIssueStage('');
    setIssueDept('');
    setIssueCategory('');
    setIssueRemarks('');
    setSubcategoryResetKey((k) => k + 1);
  };

  const headers = ['Site Eng Name','Latitude', 'Longitude', 'Site Close Via', 'Remarks' ,'Created On'];

  const issues_headers = ['Stage', 'Department', localization.subcategory, 'Remarks', 'Created By' ,'Created On'];

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getDistanceDataDailyTaskAtt(match.params.id);
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getIssuesList(match.params.id);
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
  }, [])

  useEffect(() => {
    if (siteStageData && siteStageData.length > 0) {
      let stage = [];
      siteStageData.map((obj, index) => {
        stage = [
          ...stage,
          {
            'id': obj.stage_id,
            'name': obj.name
          }
        ];
      });
      setSiteStages(stage);
    }
  }, [siteStageData])

  useEffect(() => {
    const tableData = ['name', 'lat', 'long', 'site_state_close_via','comments' ,'created_at'];
    if (dailyDistance && Object.keys(dailyDistance).length > 0) {

      const data = dailyDistance?.data.map((element) =>

          Object.assign(
              {},
              ...tableData.map((key) => ({[key]: element[key]})),
          )
      );
      data && setDailyTaskData(data);
      setPageCount(Math.ceil(dailyDistance.total / dailyDistance.per_page));
    }
  }, [dailyDistance]);

  useEffect(() => {
    const tableData = ['stage_name', 'department', 'issue_category', 'remarks','created_by' ,'created_at'];
    if (issuesList && Object.keys(issuesList).length > 0) {

      const data = issuesList?.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({[key]: element[key]})),
        )
      );
      data && setSiteIssuesList(data);
      setIssuePageCount(Math.ceil(issuesList.total / issuesList.per_page));
    }
  }, [issuesList]);

  useEffect( () => {
    let cancelled = false;
    (async () => {
        setIsLoading(true)
        try {
          if(siteId !== undefined && siteId !== null && siteId != ""){
            await getDistanceData(siteId, 'site_stage', match.params.manageId)
            if (typeof getSiteData === 'function') {
              await getSiteData(siteId)
            }
          }
        } finally {
          if (!cancelled) {
            setDistanceReady(true)
            setIsLoading(false)
          }
        }
    })()
    return () => { cancelled = true; };
  }, [siteId])

  // One location check for the site — was previously fired once per SiteStageCard.
  useEffect(() => {
    if (!getCheckLocation || !match?.params?.id) return;
    if (islatlng?.lat == null || islatlng?.lng == null) return;
    getCheckLocation(match.params.id, islatlng.lat, islatlng.lng);
  }, [getCheckLocation, match?.params?.id, islatlng?.lat, islatlng?.lng]);

  useEffect( () => {
    if (!distanceReady) return;
    setIsOpen(
      shouldShowSiteCheckinModal({
        distanceDetails,
        activeCheckin: activeDistanceCheckin,
        siteId,
        moduleType: 'site_stage',
      })
    );
  }, [distanceDetails, distanceReady, activeDistanceCheckin, siteId])

  useEffect(() => {
    setSiteId(match.params.id);
  }, []);
  useEffect(() => {
    if (getSiteStage !== null && siteId)
      (async () => {
        setIsLoading(true);
        await getSiteStage(siteId);
        if(siteDetails && siteDetails.status !=2 && siteDetails.status !=5){
          setdisplayButton('block');
        }else{
          setdisplayButton('none');
        }
        setIsLoading(false);
      })();
  }, [getSiteStage, siteId]);
  
  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      //console.log('eee ' + engDistanceData?.alreadyCheckIn);
      if(engDistanceData?.alreadyCheckIn == true) {
        toast.warning(engDistanceData?.message);
        history.push(`${baseUrl}/site-listing`);
        setTimeout(() => { 
          window.location.reload();
        },5000);
      } else {
        toast.success('Distance is successfully fetched');
        window.location.reload();
        setIsOpen(false);
        Object.keys(engDistanceData).forEach(key => {
          delete engDistanceData[key];
        })
      }
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])

  const onHoldFirst = async (e) => {
    // alert(e)
    setIsLoading(true);
    if(e){
      setStatus(5);
      setIsModal(true);
    }
    setIsLoading(false);
    
  };
  const onAbortFirst = async (e) => {
    // alert(e)
    setIsLoading(true);
    if(e){
      setStatus(6);
      setIsModal(true);
    }
    setIsLoading(false);
    
  };
  const onDismantleFirst = async (e) => {
    // alert(e)
    setIsLoading(true);
    if(e){
      setStatus(17);
      setIsModal(true);
    }
    setIsLoading(false);
    
  };

  const onLERTFirst = async (e) => {
    setIsLoading(true);
    if(e){
      setStatus(31);
      setIsModal(true);
    }
    setIsLoading(false);
  }

  const openIssuesForm = async (e) => {
    setIsLoading(true);
    if(e){
      setShowIssuesForm(true);
    }
    setIsLoading(false);

  };

  const submitIssue = async () => {
    setIsLoading(true);
    if(issueStage != '' && issueDept != '' && issueCategory != '' && issueRemarks != '') {
      let data = {
        site_id: siteId,
        stage_id: issueStage,
        dept: issueDept,
        issue_category: issueCategory,
        remarks: issueRemarks
      }
      const res = await saveSiteIssues(data);
      if(res.data.message){
        await getIssuesList(match.params.id);
        setIsLoading(false);
        handleModalHide2();
        toast.success('Issue Saved successfully!');
      }else{
        setIsLoading(false);
        toast.error('Some error occurred!');
      }

    }else{
      toast.error('Please fill all fields.');
      setIsLoading(false);
    }


  };

  const unhold = async (e) => {
    setIsLoading(true);
    if(e){
     
      const res = await siteUnhold(match.params.id);
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
      }else{
        msg = 'Success!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
      setIsLoading(false);
      
    }else{
      setIsLoading(false);
    }
    
    
  };

  const onDismantle = async (e) => {
    setIsLoading(true);
    if(e){
    //  console.log(match.params.id+' --  '+remarkData); return false;
      const res = await siteDismantle(match.params.id,4,remarkData,'Dismantle');
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
        if(res.data.response.data){
          setResponseData(res.data.response.data);
        }
      }else{
        msg = 'Success!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
     
      
    }
    setIsLoading(false);
    
  };

  
  const onLERT = async (e) => {
    setIsLoading(true);
    if(e){
      const res = await siteDismantle(match.params.id,31,remarkData,'LERT');
      var msg = '';
      var resstatus = true;
      if(res.data.message){
        msg = res.data.message;
        resstatus = res.data.status;
        if(res.data.response.data){
          setResponseData(res.data.response.data);
        }
      }else{
        msg = 'Success!';
        resstatus = true;

      }
      setIsStatusModal(msg);
      setIsResStatusModal(resstatus);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
     
      
    }
    setIsLoading(false);
    
  };

  const onDismantleCont = async (e) => {
    setIsLoading(true);
    setResponseData(null)
    if(e){
    //  console.log(match.params.id+' --  '+remarkData); return false;
      const res = await siteDismantle(match.params.id,17,remarkData,'Dismantle');
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
        if(res.data.response.data){
          setResponseData(res.data.response.data);
        }
        window.location.reload(true);
      }else{
        msg = 'Success!';
        window.location.reload(true);
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
     
      
    }
    setIsLoading(false);
    
  };
  

  const onHold = async (e) => {
    // alert(e)
    setIsLoading(true);
    if(e){
      if(remarkData && remarkReasonValue['reason']){

      const res = await siteStageStatus(match.params.id, 5,remarkData, remarkReasonValue['reason']);
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
        setIsLoading(false);
      }else{
        setIsLoading(false);
        msg = 'Site is on hold!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
      setIsLoading(false);
      }else{
        setIsLoading(false);
        msg = 'Please Fill Remark!';
      }
      
    }else{
      setIsLoading(false);
    }
    
    
  };
  const onAbort = async (e) => {
    setIsLoading(true);
    if(e){
      if(remarkData){

        const res = await siteStageStatus(match.params.id, 6,remarkData);
      var msg = '';
      if(res.data.message){
        msg = res.data.message;
      }else{
        msg = 'Site is on hold!';
      }
      setIsStatusModal(msg);
      setIsStatusSuccess(true);
      await getSiteStage(siteId);
      }else{
        msg = 'Please Fill Remark!';
      }
      
    }
    
    setIsLoading(false);
    
  };

  const headerBtns = () => {
    return (
      <Fragment>
          {renderCheckOutButton()} &nbsp;&nbsp;
        <Button
          onClick={() => openIssuesForm(true)}
          className="btn btn-primary"
        >
          {" "}
          Issues Encountered
        </Button>
         <Button
                    onClick={() => onHoldFirst(true)}
                    className="btn btn-primary"
                  >
                    {" "}
                    Hold
                  </Button>
                  
                  <Button
                  onClick={() => onAbortFirst(true)}
                  className="btn btn-transparent"
                >
                  {" "}
                  Abort
                </Button>
      </Fragment>
    );
  };

  const headerUnholdBtn = () => {
    return (
      <Fragment>
        {renderCheckOutButton()} &nbsp;&nbsp;
        {/* <Button
          onClick={() => openIssuesForm(true)}
          className="btn btn-primary"
        >
          {" "}
          Issues Encountered
        </Button> */}
         <Button
                    onClick={() => unhold(true)}
                    className="btn btn-primary"
                  >
                    {" "}
                    UnHold
                  </Button>
                  
      </Fragment>
    );
  };
  const headerAbortBtn = () => {
    return (
      <Fragment>
        {renderCheckOutButton()} &nbsp;&nbsp;
          <Button
            onClick={() => openIssuesForm(true)}
            className="btn btn-theme"
          >
            {" "}
            Issues Encountered
          </Button>
           <Button
             onClick={() => onDismantleFirst(true)}
             className="btn btn-danger"
           >
             {" "}
             Dismantle
           </Button>
           
                  
      </Fragment>
    );
  };

  const handlePopupShowOrHide = () => {
    showAttPopup(true)
  }

  const onPageChange = async (val) => {
    setIsLoading(true);
    getDistanceDataDailyTaskAtt(match.params.id, val.selected + 1);
    setIsLoading(false);
  };

  const onIssuePageChange = async (val) => {
    setIsLoading(true);
    getIssuesList(match.params.id, val.selected + 1);
    setIsLoading(false);
  };

  const handleCheckOut = async (passedId) => {
    const id = passedId || resolveDistanceRowId(distanceDetails, activeDistanceCheckin);
    if (!id) {
      toast.error('Check-in record not found.');
      return false;
    }
    const checkout_lat = Number(islatlng?.lat);
    const checkout_long = Number(islatlng?.lng);
    if (isNaN(checkout_lat) || isNaN(checkout_long)) {
      alert(localization.locationPermission);
      return false;
    }
    const site = getSiteLatLng(siteData);
    let checkout_distance = 0;
    if (site) {
      checkout_distance = calcCrow(checkout_lat, checkout_long, site.lat, site.lng);
      if (!Number.isFinite(checkout_distance)) {
        toast.error('Distance Not Fetched.');
        return false;
      }
    }
    const payload = {
      id,
      checkout_lat,
      checkout_long,
      checkout_distance_in_km: checkout_distance,
      checkout_remark: '',
    };
    try {
      const res = await axios.post(`${Config.maintenance.rmCheckOut}`, payload);
      if (isCheckoutApiSuccess(res?.data)) {
        toast.success('Checkout Successfully.');
        if (typeof refreshAfterSiteCheckout === 'function') {
          await refreshAfterSiteCheckout(siteId || match?.params?.id, 'site_stage');
        } else if (typeof getProfile === 'function') {
          await getProfile();
        }
        history.push(`${baseUrl}/site-listing`);
        return true;
      }
      toast.error(checkoutErrorMessage(res?.data));
    } catch (err) {
      toast.error(checkoutErrorMessage(err?.response?.data));
    }
    return false;
  }

  const renderCheckOutButton = () =>
    isActiveDistanceCheckin(distanceDetails) ? (
      <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
        <div class="btn-group" role="group">
          <Button
            className=" btn btn-transparent"
            onClick={() => handleCheckOut(resolveDistanceRowId(distanceDetails, activeDistanceCheckin))}
          >
            {localization.checkOut}
          </Button>
        </div>
      </div>
    ) : null;

  const headerBtns1 = () => {
    return (
      <Fragment>
        {renderCheckOutButton()}
        &nbsp;&nbsp;
        {/* <Button
          onClick={() => openIssuesForm(true)}
          className="btn btn-primary"
        >
          {" "}
          Issues Encountered
        </Button> */}
      </Fragment>
    );
  };

  const primaryHeaderButtons =
    siteDetails && siteDetails[0].status == 2
      ? headerAbortBtn
      : siteDetails &&
        siteDetails[0].status !== 2 &&
        siteDetails[0].status !== 31 &&
        siteDetails[0].status !== 32 &&
        siteDetails[0].status !== 33 &&
        siteDetails[0].status !== 4 &&
        siteDetails[0].status !== 17 &&
        siteDetails[0].status !== 5 &&
        siteDetails[0].status !== 6 &&
        siteDetails[0].status !== 14 &&
        siteDetails[0].status !== 15 &&
        userProfile &&
        userProfile.roles &&
        userProfile.roles[0].id !== 9
      ? headerBtns
      : siteDetails &&
        siteDetails[0].status === 5 &&
        siteDetails[0].status !== 4 &&
        siteDetails[0].status !== 17 &&
        userProfile &&
        userProfile.roles &&
        (userProfile.roles[0].id === 16 || userProfile.roles[0].id === 17)
      ? headerUnholdBtn
      : null;

  // Buttons2 was only for checkout when primary buttons are absent (e.g. role 9).
  // When primary already includes Check Out, Buttons2 caused a duplicate.
  const checkoutOnlyButtons =
    isActiveDistanceCheckin(distanceDetails) &&
    !primaryHeaderButtons
      ? headerBtns1
      : null;

  return (
    <Layout
      title={localization.siteStages}
      isGoback
      linkFlag={true}
      linkUrl={
        (userProfile && userProfile.roles && (userProfile.roles[0].id == 14 || userProfile.roles[0].id == 15) )?  
        `/dashboard/brand-activation/sites-listing`
        :
        `/dashboard/site-listing`
      }
      // linkUrl={
      //   (userProfile.attVal && userProfile.attVal[0] && userProfile.attVal[0].lead_id && userProfile.attVal[0].lead_id > 0 )?  
      //   `/dashboard/task-listing`
      //   :
      //   `/dashboard/site-listing`
      // }
      isLoading={isLoading}
      Buttons2={checkoutOnlyButtons}
      Buttons={primaryHeaderButtons}
    >
      {/* :(distanceDetails && distanceDetails.checkout_lat == null)? headerBtns1 */}
      <div className="row" >
      {siteDetails && siteDetails[0].site_id >0 &&   
        <>
         <div className="col-md-12 col-xs-12">
          <h4>{siteDetails[0].client_name} ({siteDetails[0].site_no}) {receivedAmount ? (receivedAmount) : ""}</h4>
         </div>
         <div className="col-md-3"></div>
        </>
      }
      {siteDetails && siteDetails[0].status === 2 && 
            
          <div className="col-md-3 col-xs-12">
              <h4 style={{'color' : 'green'}}> Live</h4>
          </div>
    
      }
      {siteDetails && siteDetails[0].status === 6 && 
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'red'}}> Aborted</span>
          </div>
      }
       {siteDetails && siteDetails[0].status === 14 && 
        
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'red'}}> Abort Approval Pending</span>
          </div>
    
      }
      {siteDetails && siteDetails[0].status === 15 && 
            
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'orange'}}> Hold Approval Pending</span>
          </div>
    
      }
      {siteDetails && siteDetails[0].status === 5 && 
                 
          <div className="col-md-3 col-xs-12">
              <span style={{'color' : 'orange'}}> Hold</span>
          </div>
    
      }
       {siteDetails && siteDetails[0].status === 4 && 
                 
                 <div className="col-md-3 col-xs-12">
                     <span style={{'color' : 'red'}}> Dismantled</span>
                 </div>
           
        }
        {siteDetails && siteDetails[0].status === 17 && 
            
            <div className="col-md-3 col-xs-12">
                <span style={{'color' : 'orange'}}> Dismantle Pending</span>
            </div>
      
        }
         {siteDetails && siteDetails[0].status === 31 && 
            
            <div className="col-md-3 col-xs-12">
                <span style={{'color' : 'orange'}}> LERT Pending</span>
            </div>
      
        }
        {siteDetails && siteDetails[0].status === 32 && 
            
            <div className="col-md-3 col-xs-12">
                <span style={{'color' : 'green'}}> LERT</span>
            </div>
      
        }
         {siteDetails && siteDetails[0].status === 33 && 
            
            <div className="col-md-3 col-xs-12">
                <span style={{'color' : 'red'}}> LERT But S/W Running</span>
            </div>
      
        }
      </div>
      {role === 9 && isOpen ?
          <div className="popup-box">
            <div className="box">
              <Link
                  to={`${baseUrl}/site-listing`}
                  className="btn btn-primary mb-4"
                  style={{'cursor': 'pointer','float':'right','border':'0px','box-shadow':'none !important','position':'relative','top':'-17px'}}
              >
                x
              </Link>
              {siteId && siteId !== undefined && siteId !== null && siteId != '' ?
                    <DistanceCalculator
                        task_id={match.params.manageId}
                        siteData={siteData}
                        getSiteData={getSiteData}
                        calculateDistance={calculateDistance}
                        siteId={siteId !== '' ? siteId : "testing"}
                        moduleType={"site_stage"}
                    /> :
                  ""}
            </div>
          </div> :
      <>  
      {(is_asset_mapping && is_asset_mapping === 1) ? 
      <>
        <span style={{color : 'red'}}><marquee ><img src={Images?.alert} style={{width:'25px'}} alt="" /> Please complete asset Mapping
        {(match && match.params && match.params.id && match.params.manageId) ?
        <a href={`/dashboard/new-site-asset-mapping/`+match.params.id+'/'+ match.params.manageId}> - Click Here</a>
        :
        <></>
        }
        </marquee></span>
      </>
      : 
      <></>
      }  
      
      <div clasName="panel-catalogue">
        <div className="panel-card-listing panel-catalogue1">
          {siteStageData && siteStageData.length > 0 ? (
            siteStageData.map((obj, index) => {
              return (
                  <>
                    <SiteStageCard
                        key={index}
                        count={index}
                        data={obj}
                        siteDetails={siteDetails}
                        latitude={latitude}
                        longitude={longitude}
                        history={history}
                        siteId={siteId}
                        isVendorAllocated={isVendorAllocated}
                        locationCheck={locationCheck}
                        match={match}
                        infraId={infraProjectId}
                        isCarnivalActive={isCarnivalScheduled}
                        baseUrl={baseUrl}
                        isPoCreated={siteStageDetails?.is_po_created}
                        isDashboardTraining={isDashboardTrainingResolved}
                    />
                  </>
              );
            })
          ) : (
            <div>Data Not Found</div>
          )}

           {siteStageDetails && siteStageDetails?.required_documents && siteStageDetails?.required_documents?.data && (
                <CardSection title={'Required Documents'}>
                  <div className="d-flex" style={{marginBottom: "10%"}}>
                      <Link to={`/dashboard/required-documents/${match?.params?.id}`}>
                        <Button className="btn-sm" style={{marginRight: "10px"}}>
                          {'Upload Documents'}
                        </Button>
                      </Link>
                      <Link to={`/dashboard/uploaded-document-list/${match?.params?.id}`}>
                        <Button className="btn-sm" style={{marginLeft: "10px"}}>
                          {'View Document List'}
                        </Button>
                      </Link>
                  </div>
                </CardSection>
              )}

           </div>

            <div className="container-fluid daily-task-container">
              <div className="card">
                <div className="card-header daily-task-header">
                  <div className="daily-header-title">{localization.dailyTask}</div>
                  {/* {role === 9 &&
                      <div className="add-daily-task">
                        <Button
                            className="btn-sm"
                            onClick={() => {
                              handlePopupShowOrHide()
                            }}
                        >
                          {localization.addDailyTask}
                        </Button>
                      </div>
                  } */}
                </div>
                <div className="card-body">
                  <TableSection
                      data={listData}
                      isId={false}
                      isMngId={false}
                      headers={headers}
                      pageCount={pageCount}
                      onPageChange={onPageChange}
                      onChange={() => {
                      }}
                      detailList={listData && listData}
                      srNo={dailyDistance?.from}
                  />
                </div>
              </div>
            </div>

        <div className="container-fluid daily-task-container">
          <div className="card">
            <div className="card-header daily-task-header">
              <div className="daily-header-title">{localization.issueEncountered}</div>
            </div>
            <div className="card-body">
              <TableSection
                data={siteIssuesList}
                isId={false}
                isMngId={false}
                headers={issues_headers}
                pageCount={issuePageCount}
                onPageChange={onIssuePageChange}
                onChange={() => {
                }}
                detailList={siteIssuesList && siteIssuesList}
              />
            </div>
          </div>
        </div>

      </div>
      </>
      }
      {isShowAttPopUp ?
          <div className="popup-box">
            <div className="box">
              {siteData?.lead_id !== undefined &&
                  <Link
                      className="btn btn-primary mb-4"
                      style={{
                        'cursor': 'pointer',
                        'border': '0px',
                        'boxShadow': 'none !important',
                        'position': 'relative',
                        'top': '-17px',
                        'float':'right'
                      }}
                      to={"#"}
                      onClick={() => {window.location.reload()}}
                  >
                    x
                  </Link>
              }

              <DistanceCalculator
                  siteData={siteData}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={'daily-task'}
                  isMapShow={false}
                  to={"#"}
              />
            </div>
          </div>
          : ""
      }

      <ModalPop
        title={localization.changeStatus}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
        {(status === 31)?
          <h5>Enter remark to LERT this site</h5>
         :
          <h5>{(status === 5)?'Enter remark to hold this site':(status === 17)?'Enter remark to dismantle this site' :'Enter remark to abort this site'}</h5>
        }
        {(status === 31)?
        <></>
        :
          (status !== 17) ? 
            <DropDownInput
                label={localization.holdReason}
                required={true}
                data={[
                  {id: "Due to delay in the carnival", name: "Due to delay in the carnival",},
                  {id: "Approval from client", name: "Approval from client",},
                  {id: "Client Unavailability", name: "Client Unavailability",},
                  {id: "Client scope Civil & Elect", name: "Client scope Civil & Elect",},
                  {id: "Construction work", name: "Construction work",},
                  {id: "Handover Delay", name: "Handover Delay",},
                  {id: "Internet", name: "Internet",},
                  {id: "Material Delay", name: "Material Delay",},
                  {id: "MY Gate Issue", name: "MY Gate Issue",},
                  {id: "Power & Earthing", name: "Power & Earthing",},
                  {id: "Vendor Team Delay", name: "Vendor Team Delay",},
                ]}
                getIdValue={(val) =>{
                  setRemarkReasonValue({
                    ...remarkReasonValue,
                    reason: val.id,
                  })
                }
                }
            />
          :null
          }
          
          <ConstantInput
                label='Remark'
                type="text"
                value={remarkData}
                handleChange={(val) =>
                  setRemarkData(val)
                }
                required
              />
        {(status === 5) &&
        <Button
        className="btn btn-primary mb-4"
        onClick={() => onHold(5)}
      >
        {localization.continue} <img src={Images?.ArrowRight} alt="" />
      </Button>
        }
         {(status === 6) &&
        <Button
        className="btn btn-theme mb-4"
        onClick={() => onAbort(6)}
      >
        {localization.continue} <img src={Images?.ArrowRight} alt="" />
      </Button>
        }
        {(status === 17) &&
        <Button
        className="btn btn-danger mb-4"
        onClick={() => onDismantle(4)}
      >
        {localization.continue} <img src={Images?.ArrowRight} alt="" />
      </Button>
        }

      {(status === 31) &&
              <Button
              className="btn btn-warning mb-4"
              onClick={() => onLERT(31)}
            >
              {localization.continue} <img src={Images?.ArrowRight} alt="" />
            </Button>
              }
         
          
        </div>
      </ModalPop>

      {/*Issues Encountered Form Modal Start*/}
      <ModalPop
        title={localization.issueEncountered}
        show={showIssuesForm}
        handleModalHide={handleModalHide2}
        keyboard
      >
        <div className="text-center">
          {/*{siteStages && siteStages.length > 0 ?*/}
          <DropDownInput
            label={localization.stage}
            required={true}
            data={siteStages}
            getIdValue={(val) =>{
              setIssueStage(val.id)
            }}
            isStarRequired={true}
          />
          <DropDownInput
            label={localization.deptDepend}
            required={true}
            data={ISSUE_DEPARTMENTS}
            getIdValue={(val) =>{
              setIssueDept(val.id)
              setIssueCategory('')
              setSubcategoryResetKey((k) => k + 1)
            }}
            isStarRequired={true}
          />
          <DropDownInput
            key={`issue-subcat-${subcategoryResetKey}`}
            label={localization.subcategory}
            required={true}
            data={getIssueSubcategories(issueDept)}
            getIdValue={(val) =>{
              setIssueCategory(val.id)
            }}
            isStarRequired={true}
            disabled={!issueDept}
          />

          <ConstantInput
            label='Remark'
            type="text"
            handleChange={(val) =>
              setIssueRemarks(val)
            }
            isStarRequired={true}
            required
          />
          <Button
            className="btn btn-theme mb-4"
            onClick={() => submitIssue()}
          >
            {localization.submit}
          </Button>
        </div>
      </ModalPop>
      {/*Issues Encountered Form Modal End*/}

      <ModalPop
        title='Status Change'
        show={isStatusSuccess}
      >
        <div className="text-center">
          {isResStatusModal ? 
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            :
            <div className="danger">
              <img src={Images?.alert} alt="" />
            </div>
           }
          <h5>{isStatusModal}</h5>
          <br/>
          {responseData ? 
          <table className='table' >
              <thead>
                <tr>
                  <th>Invoice Number</th>
                  <th>Amount</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody >
          {responseData && responseData.map((item,index) => {
            return(
              
                <tr key={{index}}>
                  <td>
                    {item.invoice_number}
                  </td>
                  <td>
                    {item.invoice_amount}
                  </td>
                  <td>
                    {item.invoice_date}
                  </td>
                </tr>
            
            );
          } )}
            </tbody>
          </table>
            : null }
             {(status === 17) &&
             
                <Button
                className="btn btn-theme mb-4"
                onClick={() => onDismantleCont(17)}
              >
                {localization.dismentalContinue} <img src={Images?.ArrowRight} alt="" />
              </Button>
              
                }
                &nbsp;
                &nbsp;
          <Link
                to={`${baseUrl}/site-listing`}
                className="btn btn-theme mb-4"
              >
            {localization.goBack}
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default SiteListing;
